import { render, staticRenderFns } from "./ChinaProvinceMap.vue?vue&type=template&id=5d248eaf&scoped=true"
import script from "./ChinaProvinceMap.vue?vue&type=script&lang=js"
export * from "./ChinaProvinceMap.vue?vue&type=script&lang=js"
import style0 from "./ChinaProvinceMap.vue?vue&type=style&index=0&id=5d248eaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d248eaf",
  null
  
)

export default component.exports